import { render, staticRenderFns } from "./BsiNavigation.vue?vue&type=template&id=3491fe91&scoped=true"
import script from "./BsiNavigation.vue?vue&type=script&lang=js"
export * from "./BsiNavigation.vue?vue&type=script&lang=js"
import style0 from "./BsiNavigation.vue?vue&type=style&index=0&id=3491fe91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3491fe91",
  null
  
)

export default component.exports